var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5947 0H1.59473C1.32951 0 1.07516 0.105357 0.88762 0.292893C0.700083 0.48043 0.594727 0.734784 0.594727 1V17C0.594727 17.2652 0.700083 17.5196 0.88762 17.7071C1.07516 17.8946 1.32951 18 1.59473 18H10.2097V11.04H7.87173V8.315H10.2097V6.315C10.2097 3.99 11.6297 2.723 13.7097 2.723C14.4087 2.721 15.1087 2.757 15.8047 2.83V5.25H14.3697C13.2417 5.25 13.0217 5.788 13.0217 6.575V8.31H15.7187L15.3687 11.035H13.0207V18H17.5947C17.8599 18 18.1143 17.8946 18.3018 17.7071C18.4894 17.5196 18.5947 17.2652 18.5947 17V1C18.5947 0.734784 18.4894 0.48043 18.3018 0.292893C18.1143 0.105357 17.8599 0 17.5947 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFacebook);
export default __webpack_public_path__ + "static/media/webFacebook.d1c63f26e178ea004e4f7a1180675c62.svg";
export { ForwardRef as ReactComponent };